import React, { useEffect, useState } from "react";
import { bool, func, number, string } from "prop-types";
import { Button, Input } from "Shared/ui";
import { useSelector } from "react-redux";
import { selectBalance } from "Features/balance/balance.select";
import { amountController } from "../lib/withdraw_amount_controller";
import { WithdrawTaxDesciption, WithdrawTaxInfo } from "../components";
import { taxSelect } from "Pages/Withdraw/store";
import "./withdraw_amount.widget.scss";

export const WithdrawAmountWidget = () => {
	const { minimal, amounCount, setAmounCount, onClick, isDisabled } = amountController();
	const balanceFetch = useSelector(selectBalance.fetch);
	const tax_data = useSelector(taxSelect.all);
	const [isReachedLimit, setIsReachedLimit] = useState(false);
	const [localCalculatedTax, setLocalCalculatedTax] = useState(undefined);

	function onOk() {
		onClick(isReachedLimit);
	}

	useEffect(() => {
		const amount = Number(amounCount);
		const is_reached_limit = tax_data.amount + amount >= tax_data.tax_free_amount;
		if (is_reached_limit != isReachedLimit) setIsReachedLimit(is_reached_limit);
		if (is_reached_limit) {
			const overLimit = tax_data.amount + amount - tax_data.tax_free_amount;
			const taxedAmount = overLimit < amount ? overLimit : amount;
			const tax = (taxedAmount / 100) * tax_data.tax_percent;
			setLocalCalculatedTax({
				tax_percent: tax_data.tax_percent,
				request_amount: amount,
				net_amount: (amount - tax).toFixed(2),
				tax_amount: tax.toFixed(2),
			});
		}
	}, [tax_data, amounCount]);

	return (
		<div className="w-a">
			<h1 className="mb-5">withdraw</h1>
			<h3 className="mb-20 orange">
				You should submit for withdrawal for your personnel account (IBAN / PayPal)! You cannot apply to transfer money
				to another person!
			</h3>
			<h2 className="mb-5">Input withdrawal amount</h2>
			<h3 className="mb-20">Minimal withdrawal amount € {minimal}</h3>
			<div className="w-a__input">
				<Input type="amount" outValue={amounCount} setOutValue={setAmounCount} />
				<div className="mb-8" />
				<h4>* your bank may charge a commission for transferring funds</h4>
			</div>
			{isReachedLimit && amounCount && (
				<WithdrawTaxInfo
					taxPercent={tax_data.tax_percent}
					inputAmount={Number(amounCount)}
					calculated={localCalculatedTax}
				/>
			)}
			<div className="mb-20">
				<Button text="Proceed" type="azure" disabled={isDisabled} onClick={onOk} isLoading={balanceFetch} />
			</div>
			{isReachedLimit && <WithdrawTaxDesciption tax={tax_data.tax_percent} limit={tax_data.tax_free_amount} />}
		</div>
	);
};

WithdrawAmountWidget.propTypes = {
	minimal: number,
	amounCount: string,
	setAmounCount: func,
	onClick: func,
	isLoading: bool,
	isDisabled: bool,
};
